import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'react-final-form-arrays';
import { Accordion, Col, Row } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import RenderAvailableLists from './AvailableLists';
import RelatedTextFields from './RelatedTextFields';
import css from '../styles.css';

function DrivationOptions({ selectableFields, fieldData }) {
  return (
    <Accordion
      id={`${fieldData.name}-drivation-options-aacordion}`}
      label={
        <FormattedMessage
          id="ui-plugin-inventory-templates.driveNewFieldsModal.derivationOptions.label"
          defaultMessage="Derivation options"
        />
      }
      separator={false}
      className={css.accContainer}
    >
      <Row>
        <Col xs={7} className={css.container}>
          <FieldArray
            id={`template-drived-fields-editor-availableLists-${fieldData.name}`}
            name="availableLists"
            component={RenderAvailableLists}
            selectableFields={selectableFields}
          />
        </Col>
        <Col xs={5} className={css.container}>
          <RelatedTextFields fieldArray={fieldData.fieldArray} />
        </Col>
      </Row>
    </Accordion>
  );
}

DrivationOptions.propTypes = {
  selectableFields: PropTypes.arrayOf(PropTypes.object),
  fieldData: PropTypes.object,
};

export default DrivationOptions;
